import { useCallback } from 'react';

const FEATURE_FLAGS_URL =
  'https://app.launchdarkly.com/projects/default/flags?env=production&selected-env=production';

export const useLaunchFeatureFlags = () => {
  return useCallback(() => {
    window.open(FEATURE_FLAGS_URL, '_blank', 'noopener,noreferrer');
  }, []);
};
